import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { MultiselectOption } from '@cbo/shared-library';
import { FormContainer } from 'react-hook-form-mui';
import * as yup from 'yup';
import Header from '../../components/Header/Header';
import ReportSection from './components/ReportSection/ReportSection';
import { rootGridSx, dropdownGridSx, sectionsGridSx } from './styles';
import Multiselect from '../../components/GlobalFilterBar/Multiselect/Multiselect';
import useYupValidationResolver from '../../utils/formUtils/yupValidationResolver';
import { mapSchemaValues } from '../../utils/reportingUtils/filterUtils';
import { CentralReportsFormType } from './models/CentralReportsFormType';

function CentralReportsPage() {
  const { t } = useTranslation();

  const options: MultiselectOption[] = [
    { label: t('admin.centralReportsPage.dropdown.asm'), id: 'ASM' },
    { label: t('admin.centralReportsPage.dropdown.kitchen'), id: 'Kitchen' },
    { label: t('navItems.menu'), id: 'Menu' },
  ];

  const formContext = useForm<CentralReportsFormType>({
    mode: 'onChange',
    defaultValues: {
      categories: [],
    },
    resolver: useYupValidationResolver(yup.object(mapSchemaValues(['categories']))),
  });

  return (
    <Grid sx={rootGridSx}>
      <Header
        maxDescriptionWidth='100%'
        dataTestId='centralized-reports-header'
        title={t('navItems.reports')}
        description={t('admin.centralReportsPage.pageSubheader')}
      />
      <FormContainer formContext={formContext}>
        <Grid item xs={12} sx={dropdownGridSx}>
          <Multiselect
            controllerName='categories'
            options={options}
            singular={t('admin.centralReportsPage.dropdown.allProducts')}
            plural={t('globalFilters.categories')}
            titleText={t('globalFilters.categories')}
            defaultChecked={false}
            loading={false}
          />
        </Grid>

        <Grid item xs={12} sx={sectionsGridSx}>
          <ReportSection sectionHeader={t('admin.centralReportsPage.sectionHeaders.favorites')} reportAmount={8} />
          <ReportSection sectionHeader={t('admin.centralReportsPage.sectionHeaders.laborReports')} reportAmount={3} />
          <ReportSection
            sectionHeader={t('admin.centralReportsPage.sectionHeaders.inventoryReports')}
            reportAmount={1}
          />
          <ReportSection sectionHeader={t('admin.centralReportsPage.sectionHeaders.salesReports')} reportAmount={7} />
          <ReportSection sectionHeader={t('admin.centralReportsPage.sectionHeaders.kitchenReports')} reportAmount={3} />
          <ReportSection sectionHeader={t('admin.centralReportsPage.sectionHeaders.menuReports')} reportAmount={2} />
        </Grid>
      </FormContainer>
    </Grid>
  );
}

export default CentralReportsPage;
